import { render, staticRenderFns } from "./messageInfo.vue?vue&type=template&id=2653ddf2&scoped=true&"
import script from "./messageInfo.vue?vue&type=script&lang=js&"
export * from "./messageInfo.vue?vue&type=script&lang=js&"
import style0 from "./messageInfo.vue?vue&type=style&index=0&id=2653ddf2&prod&scoped=true&lang=scss&"
import style1 from "./messageInfo.vue?vue&type=style&index=1&id=2653ddf2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2653ddf2",
  null
  
)

export default component.exports